import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import {
  accountNumber,
  apiKey,
  password,
  username,
  userPassMap,
} from '../internal.js'

const credentialTypes = [username, password, apiKey, accountNumber] as const

export type ccyqCredType = (typeof credentialTypes)[number]
export const ccyqDocumentTypes = [
  'delivery-photo',
  'invoice',
  'other',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const ccyq: CarrierDef<ccyqCredType> = {
  name: 'CrossCountry Freight Solutions',
  scac: 'ccyq',
  credentialTypes,
  ltlServices: [{ id: 'standard', name: 'Standard' }],
  legacyCredMap: [
    ...userPassMap,
    ['api-key', 'apiKey'],
    ['api-key', 'ref2'],
    ['account-number', 'accountNumber'], // CRED NOTE - this is prompted for in FV but (as far as I can see) never used in engine services
  ],
  engineLayers: ['rating', 'pickup', 'cancel', 'documents', 'tracking'],
  documentTypes: ccyqDocumentTypes,
  credentialConfig: {
    'account-number': { customerIdentifier: true },
  },
}
